import { BlogPost } from '@commerce/types/blog'
import { GetStaticPathsContext, GetStaticPropsContext } from 'next'
import { Layout } from '@components/common'
import commerce from '@lib/api/commerce'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { createClient } from '@lib/prismicio'
import BlogContainer from '@components/blogs/BlogContainer'
import BlogPostWrapper from '@components/blogs/BlogPostWrapper'
import { AnalyticsPageType } from '@shopify/hydrogen-react'

export async function getStaticProps({
  params,
  preview,
  previewData,
  locale,
  locales,
}: GetStaticPropsContext<{ slug: string }>) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)
  const config = { locale, locales }

  const blogPostPromise = commerce.getBlogPostByHandle({
    variables: { blogHandle: 'news', blogPostHandle: params!.slug },
    config,
  })

  const { blogPost } = await blogPostPromise

  if (!blogPost) {
    // Return revalidate so Next.js retries instead of permanently caching the 404.
    return {
      notFound: true,
      revalidate: 60,
    }
  }

  return {
    props: {
      ...globalProps,
      ...config,
      blogPost,
      analyticsPayload: {
        pageType: AnalyticsPageType.blog,
      },
    },
    revalidate: 60, // Every minute
  }
}

export async function getStaticPaths(context: GetStaticPathsContext) {
  const config = { locale: context.defaultLocale, locales: context.locales }
  const { blogPosts } = await commerce.getAllBlogPosts({
    variables: {
      first: 250,
    },
    config,
  })

  if (!blogPosts) {
    return {
      paths: [],
      fallback: 'blocking',
    }
  }

  // Get the paths we want to prerender based on data
  const paths = blogPosts.flatMap((article) => ({
    params: {
      slug: article.handle,
    },
  }))

  return { paths, fallback: 'blocking' }
}

interface Props {
  blogPost: BlogPost
  locales: string[]
  locale: string
}

interface BlogLayoutProps {
  pageProps: Props
}

export default function Slug({ blogPost }: Props) {
  console.log('post:', blogPost)
  return (
    <BlogPostWrapper blogPost={blogPost}>
      <BlogContainer>
        <div
          className="rte-content"
          dangerouslySetInnerHTML={{ __html: blogPost.contentHtml }}
        />
      </BlogContainer>
    </BlogPostWrapper>
  )
}

Slug.Layout = Layout
